<template>
    <div class="newsContent">
      <div class="wal">
        <div class="tittle">{{data.title}}</div>
        <div class="date">{{data.createTime}}</div>
        <div class="content" v-html="data.content"></div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "NewsArticle",
    methods: {
      loadData() {
        this.$common.post('article/detail/'+this.$route.params.id,
          {},(response)=>{
            this.data = response.data.content;
          }
        )
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.loadData();
      })
    },
    data() {
      return {
        data:{
          createtime:'',
        },
      }
    }
  }
</script>

<style scoped>
  .wal {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    font-size: 14px;
    white-space:pre-wrap
  }
  .newsContent {
    border-top: 1px solid #f0f0f0
  }

  .newsContent .wal {
    padding: 50px 90px;
  }

  .newsContent .wal .tittle {
    color: #333;
    font-size: 18px;
    line-height: 30px;
  }

  .newsContent .wal .content {
    padding-top: 25px
  }

  p {
    font-size: 14px;
    line-height: 100px;
    color: #666;
    margin-bottom: 25px
  }

  .newsContent .wal .content p img {
    width: 100%;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/News.vue